import { makeStyles } from '@material-ui/core';
import { bottomSheetShadow } from '../../../theme';

const useStyles = makeStyles((theme) => ({
  mobileNavigation: {
    position: ({ elementIsFocused }) => !elementIsFocused && 'sticky',
    bottom: 0,
    background: theme.palette.white.main,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    borderTop: `1px solid ${bottomSheetShadow}`,
    marginTop: 50,
    zIndex: 1301,
  },
  amountBox: {
    flexWrap: 'nowrap',
  },
  arrowIcon: {
    '& > button': {
      padding: 0,
    },
  },
  price: {
    fontSize: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down(375)]: {
      fontSize: 17,
    },
  },
  paymentTotal: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down(375)]: {
      fontSize: 15,
    },
  },
}));

export default useStyles;
